export enum LineItemType {
  CHARGE = 1,
  DISCOUNT = 2,
  PROCESSING_FEE = 3,
}
